// extracted by mini-css-extract-plugin
var _1 = "O5wdhPFbhCreTmLWg6JA";
var _2 = "sbQ_7C8Det2WgBv4GdNw";
var _3 = "fTmipo2UAgT1uJg9RGow";
var _4 = "HerRv7g1wdrTn8DMjniE";
var _5 = "DuNJEREbZIhkiP8olgwy";
var _6 = "ycOrH8vYfQGXOkxcygmL";
export { _1 as "border", _2 as "copy", _3 as "footer", _4 as "menu", _5 as "share", _6 as "subscribe" }
